const FeedbackState = ({ type = 'empty', title, message, actionLabel, onAction }) => (
  <div className={`sa-feedback-state sa-feedback-state--${type}`} role={type === 'error' ? 'alert' : 'status'}>
    <strong>{title}</strong>
    {message ? <p>{message}</p> : null}
    {actionLabel && onAction ? <button className="sa-secondary-button" type="button" onClick={onAction}>{actionLabel}</button> : null}
  </div>
);

export const LoadingTable = ({ rows = 5 }) => <div className="sa-loading-table" aria-label="Loading records" role="status">{Array.from({ length: rows }).map((_, index) => <span key={index} />)}</div>;
export default FeedbackState;
